import React from 'react';
export function HeroSection() {
  return <section className="px-5 pt-8 pb-8 max-w-[640px] mx-auto text-center" data-id="element-87">
      <div className="text-[22px] font-black tracking-tight mb-5" data-id="element-88">
        CÓDIGO<span className="text-[var(--red2)]" data-id="element-89">ROJO</span>
      </div>

      <span className="inline-block bg-[var(--red)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-5 uppercase" data-id="element-90">
        SISTEMA DE DETECCIÓN · SOLO PARA ELLA
      </span>

      <h1 className="text-[clamp(28px,7vw,42px)] font-extrabold leading-tight mb-4" data-id="element-91">
        Detecta a un hombre inconsistente antes de la tercera cita
      </h1>

      <p className="text-[var(--muted)] text-[clamp(18px,4.5vw,24px)] font-medium mb-8" data-id="element-92">
        Sin esperar meses para darte cuenta
      </p>

      <div className="h-[3px] w-[50px] bg-[var(--accent)] mx-auto my-4" data-id="element-93" />

      <p className="text-white text-[17px] leading-relaxed my-4 max-w-[520px] mx-auto" data-id="element-94">
        Deja de interpretar señales y empieza a evaluarlas. Código Rojo te
        muestra exactamente qué mirar en su comportamiento desde el inicio para
        que sepas si va en serio o solo te hace perder el tiempo.
      </p>

      <img src="https://cdn.magicpatterns.com/uploads/1mkcCx5qgG7GVWdRXtnRYk/IMG_8815.png" alt="Código Rojo — Sistema de Detección" className="w-full max-w-[420px] rounded-2xl mx-auto mt-4 mb-6 block" data-id="element-95" />

      <a href="https://www.auditoriacodigorojo.decidirconclaridad.com/checkouts/cn/hWNBZNo3vNtVEtV4LiscjXus/es-us" target="_blank" rel="noopener noreferrer" className="block bg-[var(--red2)] text-white text-center py-4 px-6 rounded-xl font-bold text-[13px] sm:text-[15px] tracking-wider max-w-[420px] mx-auto hover:bg-[#a82040] transition-colors" data-id="element-96">
        QUIERO SABER SI VA EN SERIO — $17
      </a>

      <p className="text-[var(--muted)] text-xs mt-3" data-id="element-97">
        Acceso inmediato. Lo ves hoy mismo.
      </p>
    </section>;
}